export const CHANGELOG_VERSION = "2026-08-12-v1";
export const CHANGELOG_STORAGE_KEY = "dance-mirror-changelog-seen";
export const CHANGELOG_DATE = "August 2026";

export type ChangelogEntryType = "feature" | "fix" | "improvement";

export interface ChangelogEntry {
  type: ChangelogEntryType;
  title: string;
  description: string;
}

export const CHANGELOG_ENTRIES: ChangelogEntry[] = [
  {
    type: "improvement",
    title: "Larger upload support",
    description: "Signed-in users can now upload video files up to 4 GB — no more hitting a wall on longer recordings.",
  },
  {
    type: "improvement",
    title: "More reliable uploads",
    description: "Uploads now retry automatically if your connection drops mid-transfer, with clearer messages if something goes wrong.",
  },
  {
    type: "improvement",
    title: "See what Pro unlocks",
    description: "Paid features like Playlists are now visible in your library so you always know what's available on a Pro plan.",
  },
  {
    type: "feature",
    title: "Audio Practice Mode",
    description: "Practice your routines with audio tracks — adjust tempo and pitch to match your pace.",
  },
  {
    type: "feature",
    title: "Side-by-Side Compare",
    description: "Load two videos at once and play them in sync to spot differences in your technique.",
  },
];
